<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="courseDialogClose"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="120px"
    >
      <!-- <el-form-item label="所属企业" prop="enterpriseId">
        <el-select
          clearable
          filterable
          v-model="dataForm.enterpriseId"
          placeholder="请选择"
          @change="handleChangeEnterprise()"
        >
          <el-option
            v-for="item in unitList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属父部门" prop="parentName">
        <el-popover
          ref="deptListPopover"
          placement="bottom-start"
          trigger="click"
        >
          <el-tree
            :data="deptList"
            :props="deptListTreeProps"
            node-key="id"
            ref="deptListTree"
            @current-change="deptListTreeCurrentChangeHandle"
            :default-expand-all="false"
            :highlight-current="true"
            :expand-on-click-node="false"
            class="tree"
          >
          </el-tree>
        </el-popover>
        <el-input
          v-model="dataForm.parentName"
          v-popover:deptListPopover
          :readonly="true"
          placeholder="点击选择所属部门"
          class="menu-list__input"
        ></el-input>
      </el-form-item> -->

      <el-form-item label="标题" prop="title">
        <el-input v-model="dataForm.title" placeholder="标题"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="orderNumber">
        <el-input-number
          v-model="dataForm.orderNumber"
          controls-position="right"
          :min="0"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="上传文件">
        <video-upload
          ref="videoUploaded"
          @videoUploaded="videoUploaded"
          @removeVideo="removeVideo"
          :videoList="preVideo"
        />
      </el-form-item>
      <el-form-item label="文件外链">
        <el-input
          v-model="dataForm.link"
          placeholder="请输入文件外链"
          @input="isHaveVideo"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="类型" prop="type">
                    <el-radio-group v-model="dataForm.type">
                  
                        <el-radio label="1">飘窗</el-radio>
                    </el-radio-group>
                </el-form-item> -->
      <!-- <el-radio label="0">承诺书附件</el-radio> -->
      <!-- <el-form-item label="部门代码" prop="departmentCode">
        <el-input
          v-model="dataForm.departmentCode"
          placeholder="部门代码(可添加多个部门ID，用逗号隔开，表示该部门可以管理多个部门)"
        ></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="预留1" prop="parameter1">
        <el-input v-model="dataForm.parameter1" placeholder="预留1"></el-input>
      </el-form-item>
      <el-form-item label="预留2" prop="parameter2">
        <el-input v-model="dataForm.parameter2" placeholder="预留2"></el-input>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { treeDataTranslate } from "@/utils";
import { showcontent } from "@/utils/method.js";
import VideoUpload from "@/views/modules/config/child-components/upload-test";

export default {
  components: {
    // Editor
    VideoUpload,
  },
  data() {
    return {
      radio: "1",
      visible: false,
      dataForm: {
        id: 0,
        parentId: "",
        enterpriseId: "",
        departmentCode: "",
        title: "",
        parameter1: "",
        parameter2: "",
        orderNumber: "0",
        parentName: "",
        type: "1",
        link: "",
      },
      unitList: [],
      preVideo: [],
      deptList: [],
      deptListTreeProps: {
        label: "name",
        children: "children",
      },
      dataRule: {
        parentName: [
          { required: true, message: "所属父部门不能为空", trigger: "blur" },
        ],
        enterpriseId: [
          { required: true, message: "所属企业不能为空", trigger: "blur" },
        ],
        departmentCode: [
          { required: true, message: "部门代码不能为空", trigger: "blur" },
        ],
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        parameter1: [
          { required: false, message: "预留1不能为空", trigger: "blur" },
        ],
        parameter2: [
          { required: false, message: "预留2不能为空", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    "activities.type": function (val) {
      console.log(val);
      if (val === "0") {
        // this.activities.link = "";
      } else {
        // this.activities.link
      }
    },
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        // this.getUnitList();
        // this.getDeptList();
        if (this.dataForm.id) {
          console.log(this.dataForm.id);
          this.$http({
            url: this.$http.adornUrl(
              `/bayWindow/findById?id=${this.dataForm.id}`
            ),
            method: "get",
            // params: this.$http.adornParams(),
            // data:{id:this.dataForm.id}
          }).then(({ data }) => {
            console.log(data);
            if (data && data.code === 0) {
              this.dataForm.parentId = data.data.parentId;
              this.dataForm.enterpriseId = data.data.enterpriseId;
              this.dataForm.id = data.data.id;
              this.dataForm.title = showcontent(data.data.title);
              this.dataForm.type = data.data.type;
              this.dataForm.orderNumber = data.data.orderNumber;
              if (data.data.link) {
                this.dataForm.link = data.data.link;
                let a = "";
                if (data.data.link.split("--")[1]) {
                  a = decodeURIComponent(data.data.link.split("--")[1]);
                } else {
                  a = "飘窗链接";
                }

                console.log(a);
                this.preVideo = [{ name: a, url: data.data.link }];
              }
              // this.deptListTreeSetCurrentNode();
            }
          });
        }
      });
    },
    isHaveVideo() {},
    // 视频上传完成
    videoUploaded(url, name) {
      console.log(name);
      // debugger
      // console.log(this.news.enclosure);
      if (this.dataForm.link != undefined && this.dataForm.link != "") {
        this.$refs.videoUploaded.clearFiles();
        this.$message({
          title: "错误",
          type: "error",
          message: "视频外链已上传，请删除后选择文件上传",
        });
      } else {
        this.dataForm.link = url;
      }
    },
    // 关闭对话框触发事件
    courseDialogClose() {
      this.$refs["dataForm"].resetFields();
      //   this.preImg = [];
      Object.keys(this.dataForm).forEach((item) => {
        if (item === "id") {
          this.dataForm[item] = null;
        } else if (item === "sort") {
          this.dataForm[item] = 0;
        } else {
          this.dataForm[item] = "";
        }
      });
      this.preVideo = [];
      // this.dataForm = []
    },
    // 移除上传的视频
    removeVideo() {
      this.dataForm.link = "";
    },
    // 表单提交
    dataFormSubmit() {
      console.log(this.dataForm)
      // return
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(
              `/bayWindow/${!this.dataForm.id ? "add" : "update"}`
            ),
            method: "post",
            data: this.$http.adornData({
              id: this.dataForm.id || undefined,
              // parentId: this.dataForm.parentId,
              // enterpriseId: this.dataForm.enterpriseId,
              // departmentCode: this.dataForm.departmentCode,
              title: this.dataForm.title,
              // parameter1: this.dataForm.parameter1,
              // parameter2: this.dataForm.parameter2,
              link: this.dataForm.link,
              type: '1',
              orderNumber:this.dataForm.orderNumber
            }),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 获取企业树
    getUnitList() {
      this.$http({
        url: this.$http.adornUrl("/enterprise/getEnterpriseTree"),
        method: "get",
        params: this.$http.adornParams(),
      }).then(({ data }) => {
        console.log("getEnterpriseTree", data);
        this.unitList = data.data;
      });
    },
    // 获取企业部门树
    getDeptList() {
      this.dataForm.enterpriseId = this.dataForm.enterpriseId || "";
      this.deptList = [];
      this.$http({
        url: this.$http.adornUrl(
          "/enterprise/enterpriseDepartment/getDeptSelectTree?enterpriseId=" +
            this.dataForm.enterpriseId
        ),
        method: "get",
        params: this.$http.adornParams(),
      }).then(({ data }) => {
        this.deptList = treeDataTranslate(data.data, "id", "parentId");
        console.log("deptList", data);
      });
    },
    // 企业部门树选中
    deptListTreeCurrentChangeHandle(data) {
      this.dataForm.parentId = data.id;
      this.dataForm.parentName = data.name;
    },
    // 企业部门树设置当前选中节点
    deptListTreeSetCurrentNode() {
      this.$refs.deptListTree.setCurrentKey(this.dataForm.parentId);
      this.dataForm.parentName = (this.$refs.deptListTree.getCurrentNode() ||
        {})["name"];
    },
    // 企业选择改变
    handleChangeEnterprise() {
      this.getDeptList();
    },
  },
};
</script>
<style scoped>
.tree {
  max-height: 250px;
  overflow-y: auto;
}
/*滚动条整体部分*/
.tree::-webkit-scrollbar {
  width: 6px;
  background-color: rgba(217, 217, 217, 0.3);
}

/*滚动条里面的小方块，能向上向下移动*/
.tree::-webkit-scrollbar-thumb {
  background-color: rgba(217, 217, 217, 0.3);
  border-radius: 6px;
}

/*滚动条的轨道（里面装有Thumb）*/
.tree::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(217, 217, 217, 0.3);
  background-color: #fff;
}
</style>
